import PageShell from "@/components/PageShell";
import CityResourcesSection from "@/components/home/CityResourcesSection";
import QuiContacterSection from "@/components/home/QuiContacterSection";

export default function RessourcesPage() {
  return (
    <PageShell>
      <CityResourcesSection />
      <QuiContacterSection />
    </PageShell>
  );
}
